import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allClients } from 'app/mocks/data/park/clients'
import { allProfiles } from 'app/mocks/data/users/profiles'
import { allPermissions } from 'app/mocks/data/users/profiles/permissions'

import { api } from 'app/utils/constants'

import { Profile, ProfilePayload } from 'app/types/users/profile'

export const updateProfile = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.profiles.DETAILS}`,
    async ({ request, params }) => {
        const { id } = params

        const payload = await request.json()
        const payloadParsed = ProfilePayload.safeParse(payload)

        const profileFound = allProfiles.find(
            (profile) => profile.id.toString() === id,
        )

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        // Not found
        if (!profileFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Profile>({
            ...profileFound,
            ...payloadParsed.data,
            client: allClients.find(
                (client) => client.id === payloadParsed.data.client,
            ),
            permissions: allPermissions.filter((permission) =>
                payloadParsed.data.permissions.includes(permission.id),
            ),
        })
    },
)
